module.exports = __webpack_public_path__ + "static/media/share-alt.8ef9adb2.svg";